import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { Row, Col } from '@si-armes/dsfr-react';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import * as PropTypes from 'prop-types';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import {
    API_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID,
    CONTEXT_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID,
} from '../../../../../../../constants/apiUrls.constants';
import usagerClientReducer from '../../../../../../../store/usagerReducer';
import ArmeCorrigerInformationsEtape1 from './etape1/ArmeCorrigerInformationsEtape1';
import ArmeCorrigerInformationsEtape2 from './etape2/ArmeCorrigerInformationsEtape2';

const ArmeCorrigerInformations = ({ getApi, reinitialiseApi, isLoading, arme }) => {
    const [armeRecuperer, setArmeRecuperer] = useState([]);
    const { uuidArmeSelec } = useParams();
    const [armeCorrigerInformations, setArmeCorrigerInformations] = useState({
        erreur: null,
    });
    const [etape, setEtape] = useState(0);

    useEffect(() => {
        reinitialiseApi(CONTEXT_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID);
        return () => {
            reinitialiseApi(CONTEXT_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID);
        };
    }, []);

    useEffect(() => {
        if (!Array.isArray(arme)) {
            getApi(
                usagerClientReducer,
                API_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID + uuidArmeSelec,
                CONTEXT_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID,
            );
        }
    }, []);

    useEffect(() => {
        if (arme !== null && Array.isArray(Object.values(arme))) {
            const liste = [];

            Object.entries(arme).forEach(([, value]) => {
                liste.push(value);
            });
            setArmeCorrigerInformations({ uuidArme: uuidArmeSelec });
            setArmeRecuperer(liste);
            setEtape(1);
        }
    }, [arme]);

    const tableauConfig = [
        'Numéro RGA',
        'Numéro de série',
        'Type',
        'Marque',
        'Modèle',
        'Calibre',
        'Régime de détention',
        "Date d'acquisition",
    ];

    const setEtapeUn = () => {
        setEtape(1);
    };

    const setEtapeDeux = () => {
        setEtape(2);
    };

    const updateCorrigerInformationsArmeData = (object) => {
        Object.entries(object).map(([key, value]) =>
            setArmeCorrigerInformations((prevState) => ({
                ...prevState,
                [key]: value,
            })),
        );
    };

    return (
        <div>
            <Row>
                <Col>
                    <h2>Arme sélectionnée</h2>
                </Col>
            </Row>

            <Row>
                <Col>
                    <SimpleTable
                        isLoading={isLoading}
                        entete={tableauConfig}
                        donnees={[armeRecuperer]}
                    />
                </Col>
            </Row>
            {etape === 1 ? (
                <ArmeCorrigerInformationsEtape1
                    handleUpdateInformationsArmeData={updateCorrigerInformationsArmeData}
                    etapeSuivante={setEtapeDeux}
                    armeCorrigerInformations={armeCorrigerInformations}
                />
            ) : null}

            {etape === 2 ? (
                <ArmeCorrigerInformationsEtape2
                    etapePrecedente={setEtapeUn}
                    armeCorrigerInformations={armeCorrigerInformations}
                    tableauConfig={tableauConfig}
                />
            ) : null}
        </div>
    );
};

ArmeCorrigerInformations.propTypes = {
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    arme: PropTypes.object,
    isLoading: PropTypes.bool,
};
export default connect(
    (state) => {
        const { isLoading, data } = state.repriseDeDonnees.recupererArme;
        return {
            isLoading,
            arme: data,
        };
    },
    {
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ArmeCorrigerInformations);
